var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"group-id":_vm.id,"auth-rules":"supervisor|admin|trainer|mentor","limitation":"questionnaire"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var admin = ref.admin;
return [_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('questionnaires',{staticClass:"mb-auto",staticStyle:{"width":"100%"},attrs:{"group-id":_vm.id,"disabled":admin}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }